import { render, staticRenderFns } from "./HeaderTransparent.vue?vue&type=template&id=20e2efc2&scoped=true"
import script from "./HeaderTransparent.vue?vue&type=script&lang=js"
export * from "./HeaderTransparent.vue?vue&type=script&lang=js"
import style0 from "./HeaderTransparent.vue?vue&type=style&index=0&id=20e2efc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2efc2",
  null
  
)

export default component.exports